import api from "@/api";

import { GET_COMPANY_NEWS, GET_HOME_NEWS } from "./types";

export default {
  [GET_COMPANY_NEWS]: async ({ commit, state, getters }, data = {}) => {
    const { getPersonalAccountInfo } = getters;
    const { personalAccount } = getPersonalAccountInfo;
    const companyId = personalAccount.manageorganizationId;

    const resp = await api.news.getNews({
      ...data,
      manage_organization_id: companyId
    });

    commit(GET_COMPANY_NEWS, resp.data);
    return resp.data;
  },

  [GET_HOME_NEWS]: async ({ commit, state, getters }, data = {}) => {
    const { getPersonalAccountInfo } = getters;
    const { personalAccount, apartment } = getPersonalAccountInfo;
    const companyId = personalAccount.manageorganizationId;
    const premiseId = apartment.premiseId;

    const resp = await api.news.getNews({
      ...data,
      manage_organization_id: companyId,
      premiseId
    });

    commit(GET_HOME_NEWS, resp.data);
    return resp.data;
  }
};
